<template>
  <div v-if="projectInfo!=null" class="projectInfo-box">
    <div class="mian-box">
      <div class="projectInfo-info d_jump">
        <div class="projectInfo-info-content">
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目部门</div>
            <div class="projectInfo-info-value">{{projectInfo.deptName}}</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目名称</div>
            <div class="projectInfo-info-value">{{projectInfo.projectName}}</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目编号</div>
            <div class="projectInfo-info-value">{{projectInfo.projectCode}}</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">下单公司</div>
            <div class="projectInfo-info-value">{{projectInfo.orderCompany}}</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">合作金额</div>
            <div class="projectInfo-info-value">{{projectInfo.proIncomeBudget|NumFormat}}元</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目地点</div>
            <div class="projectInfo-info-value">{{projectInfo.projectAddress}}</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目期限</div>
            <div
              class="projectInfo-info-value"
            >{{projectInfo.proStartDate}}至{{projectInfo.proEndDate}}</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目负责人</div>
            <div class="projectInfo-info-value">
              <div class="selected-box">
                <div class="selected-item">
                  <img
                    class="headimg"
                    :src="projectInfo.pMEmployeeHead&&projectInfo.pMEmployeeHead.length>0?projectInfo.pMEmployeeHead:require('@/assets/images/defaultHead.png')"
                  />
                  <label>{{projectInfo.pMEmployeeName}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目组成员</div>
            <div class="projectInfo-info-value">
              <div class="selected-box">
                <div
                  v-for="(item,index) in projectInfo.teamMember"
                  :key="index"
                  class="selected-item"
                >
                  <img
                    @click="openProfile(item.dingDingId)"
                    class="headimg"
                    :src="item.proMemEmployeeHeadPath&&item.proMemEmployeeHeadPath.length>0?item.proMemEmployeeHeadPath:require('@/assets/images/defaultHead.png')"
                  />
                  <label>{{item.proMemEmployeeName}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">预估净利润</div>
            <div
              v-if="projectInfo.expenditureBudget&&projectInfo.expenditureBudget.totalAmount"
              class="projectInfo-info-value"
            >{{(projectInfo.proIncomeBudget-projectInfo.expenditureBudget.totalAmount)|NumFormat}}元</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">利润率</div>
            <div
              v-if="projectInfo.expenditureBudget&&projectInfo.expenditureBudget.totalAmount"
              class="projectInfo-info-value"
            >{{(((projectInfo.proIncomeBudget-projectInfo.expenditureBudget.totalAmount)/projectInfo.proIncomeBudget)*100)|NumFormat}}%</div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">项目说明</div>
            <div
              class="projectInfo-info-value"
              v-html="$options.filters.textareaToFormat(projectInfo.projectRemark)"
            ></div>
          </div>
          <div class="projectInfo-info-box">
            <div class="projectInfo-info-label">方案书</div>
            <div class="projectInfo-info-value">
              <filebox message="暂无方案书相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <!--项目人工投入信息开始-->
        <div v-if="projectInfo.workDoneInput&&projectInfo.workDoneInput.salesman">
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">人工投入</div>
              <div class="purchase-order-Total">
                总时长
                <span>{{(projectInfo.workDoneInput.salesman+projectInfo.workDoneInput.agencyChannel+projectInfo.workDoneInput.operate+projectInfo.workDoneInput.synthesize+projectInfo.workDoneInput.activity+projectInfo.workDoneInput.creativePlanning+projectInfo.workDoneInput.contentGather)|NumFormat}}小时</span>
              </div>
              <div class="ReimItem-content">
                <div class="ReimItem-box">
                  <div class="ReimItem">
                    <div class="ReimItem-label">销售人员</div>
                    <div class="ReimItem-vlue">{{projectInfo.workDoneInput.salesman}}小时</div>
                    <div class="ReimItem-label">代理渠道支持</div>
                    <div class="ReimItem-vlue">{{projectInfo.workDoneInput.agencyChannel}}小时</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">运营支持</div>
                    <div class="ReimItem-vlue">{{projectInfo.workDoneInput.operate}}小时</div>
                    <div class="ReimItem-label">综合支持</div>
                    <div class="ReimItem-vlue">{{projectInfo.workDoneInput.synthesize}}小时</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">活动支持</div>
                    <div class="ReimItem-vlue">{{projectInfo.workDoneInput.activity}}小时</div>
                    <div class="ReimItem-label">创意策划</div>
                    <div class="ReimItem-vlue">{{projectInfo.workDoneInput.creativePlanning}}小时</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">内容采编</div>
                    <div
                      style="border-right:0"
                      class="ReimItem-vlue"
                    >{{projectInfo.workDoneInput.contentGather}}小时</div>
                    <div style="border-right:0" class="ReimItem-label"></div>
                    <div class="ReimItem-vlue"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目人工投入信息结束-->
          <!--项目支出预算明细开始-->
        <div
          v-if="projectInfo.expenditureBudget!=null&&projectInfo.expenditureBudget.projectExpenditureBudgets!=null&&projectInfo.expenditureBudget.projectExpenditureBudgets.length>0"
        >
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">支出预算</div>
              <div class="purchase-order-Total">
                总金额
                <span>{{projectInfo.expenditureBudget.totalAmount|NumFormat}}元</span>
              </div>
              <div class="ReimItem-content">
                <div class="ReimItem-box1">
                  <div
                    class="ReimItem1"
                    v-for="(expenditureItem,index) in projectInfo.expenditureBudget.projectExpenditureBudgets"
                    :key="index+400"
                  >
                    <div class="ReimItem-vlue1">{{expenditureItem.budgetName}}</div>
                    <div class="ReimItem-label1">{{expenditureItem.budgetAmount|NumFormat}}元</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目支出预算明细结束-->

        <!--项目收入预算明细开始-->
        <div
          v-if="projectInfo.revenueBudget!=null&&projectInfo.revenueBudget.projectRevenueBudgets!=null&&projectInfo.revenueBudget.projectRevenueBudgets.length>0"
        >
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">收入预算</div>
              <div class="purchase-order-Total">
                总金额
                <span>{{projectInfo.revenueBudget.totalAmount|NumFormat}}元</span>
              </div>
              <div
                v-for="(revenueItem,index) in projectInfo.revenueBudget.projectRevenueBudgets"
                :key="index+200"
                class="ReimItem-content"
              >
                <div class="ReimItem-box">
                  <div class="ReimItem">
                    <div class="ReimItem-label">合同名称</div>
                    <div class="ReimItem-vlue">{{revenueItem.contractName}}</div>
                    <div class="ReimItem-label">合同金额</div>
                    <div
                      style="color: #333333;"
                      class="ReimItem-label"
                    >{{revenueItem.contractAmount|NumFormat}}元</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">收入名称</div>
                    <div class="ReimItem-vlue">{{revenueItem.budgetName}}</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">收入说明</div>
                    <div class="ReimItem-vlue">{{revenueItem.budgetComment}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目收入预算明细结束-->
       
        <!--支出实际（已报销） 开始-->
        <div v-if="projectInfo.passExpenditure.length>0">
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">支出实际（已报销）</div>
              <div class="purchase-order-Total">
                总金额
                <span>{{totalAmount}}元</span>
              </div>
              <div class="ReimItem-content">
                <div
                  v-for="(passItem,index) in projectInfo.passExpenditure"
                  :key="index+400"
                  class="ReimItem-box"
                >
                  <div class="ReimItem">
                    <div class="ReimItem-label">申请人</div>
                    <div class="ReimItem-vlue">{{passItem.employeeName}}</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">日期</div>
                    <div class="ReimItem-vlue">{{passsItem.applyDate}}</div>
                    <div class="ReimItem-label">金额</div>
                    <div class="ReimItem-vlue">{{passsItem.amount|NumFormat}}元</div>
                  </div>
                  <div class="ReimItem">
                    <div
                      style="justify-content:center; align-items: self-end;"
                      class="ReimItem-label"
                    >备注</div>
                    <div class="ReimItem-vlue">{{passsItem.useFundsExplain}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--支出实际（已报销） 结束-->

        <!--支出实际（审批中） 开始-->
        <div v-if="projectInfo.passimgExpenditure.length>0">
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">支出实际（审批中）</div>
              <div class="purchase-order-Total">
                总金额
                <span>{{totalAmounting}}元</span>
              </div>
              <div class="ReimItem-content">
                <div
                  v-for="(item,index) in projectInfo.passimgExpenditure"
                  :key="index+300"
                  class="ReimItem-box"
                >
                  <div class="ReimItem">
                    <div class="ReimItem-label">申请人</div>
                    <div class="ReimItem-vlue">{{item.employeeName}}</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">日期</div>
                    <div class="ReimItem-vlue">{{item.applyDate}}</div>
                    <div class="ReimItem-label">金额</div>
                    <div class="ReimItem-vlue">{{item.amount|NumFormat}}元</div>
                  </div>
                  <div class="ReimItem">
                    <div
                      style="justify-content:center; align-items: self-end;"
                      class="ReimItem-label"
                    >备注</div>
                    <div class="ReimItem-vlue">{{item.useFundsExplain}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--支出实际（审批中） 结束-->
        <!--备注开始-->
        <div class="divide-line"></div>
        <div class="purchaseInfo-content">
          <div class="purchase-order">
            <div class="ReimItem-content">
              <div style="border: 0" class="ReimItem-box">
                <div style="border: 0" class="ReimItem">
                  <div
                   
                    style="border: 0;align-items: self-end;padding: 0.13rem; "
                    class="ReimItem-label"
                  >备注</div>
                  <div
                    style="border: 0;justify-content:left; align-items: self-end;"
                    class="ReimItem-vlue"
                     v-html="$options.filters.textareaToFormat(projectInfo.budgetRemark)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--备注结束-->
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/http";
import * as dd from "dingtalk-jsapi";
export default {
  data() {
    return {
      projectInfo: {},
      fileInfo: {}
    };
  },
  computed: {
    totalAmount: function() {
      debugger;
      var sum = 0;
      if (
        this.projectInfo.passExpenditure &&
        this.projectInfo.passExpenditure.length > 0
      ) {
        for (var i = this.projectInfo.passExpenditure.length - 1; i >= 0; i--) {
          sum += this.projectInfo.passExpenditure[i].amount;
        }
      }
      return sum;
    },
    totalAmounting: function() {
      debugger;
      var sum = 0;
      if (
        this.projectInfo.passimgExpenditure &&
        this.projectInfo.passimgExpenditure.length > 0
      ) {
        for (
          var i = this.projectInfo.passimgExpenditure.length - 1;
          i >= 0;
          i--
        ) {
          sum += this.projectInfo.passimgExpenditure[i].amount;
        }
      }
      return sum;
    }
  },
  methods: {
    getProjectInfo(projectCode) {
      this.$Spin.show();
      let _this = this;
      return new Promise((resolve, reject) => {
        http
          .get(`/api/BD/Project/getProjectInfo?projectCode=${projectCode}`)
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.fileInfo = {
                filesrcs: res.data.data.proFilePath,
                filenames: res.data.data.proFileName
              };
              resolve(res.data.data || null);
            } else resolve(null);
          });
      });
    },
      openProfile(dingdingUserId) {
      if (dingdingUserId.length > 0) {
        let _this = this;
        dd.biz.util.open({
          name: "profile", //页面名称
          params: { id: dingdingUserId, corpId: _this.dingdingconfig.corpId }, //传参
          onSuccess: function() {
            /**/
          },
          onFail: function(err) {}
        });
      }
    }
  },
  async mounted() {
    let _this = this;
    this.getProjectInfo(this.$route.query.projectCode).then(res => {
      _this.projectInfo = res;
    });
  }
};
</script>
<style lang="less" scoped>
.projectInfo-box {
  .projectInfo-headers {
    padding: 0 0.4rem;
  }

  .mian-box {
    .projectInfo-info {
      .projectInfo-info-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .projectInfo-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .projectInfo-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .projectInfo-info-value {
            margin-left: 0.2rem;
            width: 76%;
            color: #333333;
            .selected-box {
              height: auto;
              display: flex;
              flex-wrap: wrap;
              .selected-item {
                height: 0.8rem;
                margin-right: 0.4rem;
                font-size: 0.346667rem;
                img {
                  vertical-align: middle;
                }
                .headimg {
                  width: 0.533333rem;
                  height: 0.533333rem;
                  margin-right: 0.133333rem;
                  border-radius: 50%;
                }
                label {
                  vertical-align: middle;
                }
                .delete-bnt {
                  width: 0.2rem;
                  height: 0.2rem;
                }
              }
            }
          }
        }
      }
      .divide-line {
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .purchaseInfo-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order {
          .purchase-order-Total {
            height: 1.44rem;
            line-height: 1.44rem;
            font-size: 0.373333rem;
            color: #999999;
            padding-left: 0.4rem;
            span {
              color: #333333;
            }
          }
          .purchase-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .ReimItem-content {
            margin-top: 0.533333rem;
                        .ReimItem-box1 {
              display: flex;
              flex-wrap: wrap;
              border-right: 1px solid #eee;
              border-bottom: 1px solid #eee;
              color: #333333;
              .ReimItem1 {
                width: 50%;
                display: flex;
                border-left: 1px solid #eee;
                .ReimItem-label1 {
                  width: 2.5rem;
                  border-top: 1px solid #eee;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                .ReimItem-vlue1 {
                  border-top: 1px solid #eee;
                  flex: 1;
                  padding: 0.13rem;
                  border-right: 1px solid #eee;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  min-height: 1.066667rem;
                }
              }
            }
            .ReimItem-box {
              border-bottom: 1px solid #eee;
              .ReimItem {
                display: flex;
                border-left: 1px solid #eee;
                font-size: 0.373333rem;
                .ReimItem-label {
                  width: 2rem;
                  color: #999;
                  border-top: 1px solid #eee;
                }
                .ReimItem-vlue {
                  border-top: 1px solid #eee;
                  flex: 1;
                  color: #333333;
                  padding: 0.13rem;
                }
                .remark-label {
                  flex: 33.333333333%;
                  border-top: 1px solid #eee;
                }
                .remark-vlue {
                  flex: 66.666666666%;
                  border-top: 1px solid #eee;
                  padding: 0.13rem;
                }
                div {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  min-height: 1.066667rem;
                  border-right: 1px solid #eee;
                }
              }
            }
          }
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/BD/Project/ProjectInfo.vue